export default __webpack_public_path__ + "static/media/sk.5bb982ad.svg";